import React, { useState } from 'react';
import { LuArrowRight } from 'react-icons/lu';
import { trackContact } from '../AnalyticsEvents/MetaPixelEvents';

export default function ContactForm() {
  const [formStatus, setFormStatus] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setFormStatus('');

    const { name, email, job, message } = e.target.elements;
    const formData = {
      fullName: name.value,
      email: email.value,
      reason: job.value,
      message: message.value,
    };

    try {
      const response = await fetch(global.SERVIP + '/guest/send-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      const result = await response.json();

      if (response.ok) {
        trackContact();
        setFormStatus('Message sent. We\'ll reply by email within 24 hours.');
        e.target.reset();
      } else {
        throw new Error(result.message || 'Failed to send message');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setFormStatus(`Couldn't send: ${error.message}`);
    } finally {
      setSubmitting(false);
    }
  };

  const isSuccess = formStatus.startsWith('Message sent');

  return (
    <form className="ct-form" onSubmit={onSubmit}>
      <div className="ct-form-row">
        <div className="ct-field">
          <label htmlFor="ct-name">Full name</label>
          <input id="ct-name" name="name" type="text" placeholder="Jane Doe" required />
        </div>
        <div className="ct-field">
          <label htmlFor="ct-email">Email</label>
          <input id="ct-email" name="email" type="email" placeholder="you@example.com" required />
        </div>
      </div>

      <div className="ct-field">
        <label htmlFor="ct-job">Topic</label>
        <select id="ct-job" name="job" defaultValue="Setup">
          <option value="Pricing">Pricing</option>
          <option value="Setup">Setup</option>
          <option value="Technical issue">Technical issue</option>
          <option value="Other">Other</option>
        </select>
      </div>

      <div className="ct-field">
        <label htmlFor="ct-message">Message</label>
        <textarea
          id="ct-message"
          name="message"
          rows="6"
          placeholder="What can we help with?"
          required
        />
      </div>

      <div className="ct-form-actions">
        <button type="submit" className="ct-form-submit" disabled={submitting}>
          {submitting ? 'Sending…' : 'Send message'}
          {!submitting && <LuArrowRight size={15} strokeWidth={2} />}
        </button>
        {formStatus && (
          <p className={`ct-form-status ${isSuccess ? 'ct-form-status--ok' : 'ct-form-status--err'}`}>
            {formStatus}
          </p>
        )}
      </div>
    </form>
  );
}
